import { Module } from "wrapper6";

var $ = jQuery;

export default class SmoothScroll extends Module {

	ready(app) {

        const SCROLL_LINKS = document.querySelectorAll('#main_nav a[href^="#"]');

        if (SCROLL_LINKS.length) {
            for (let i = 0; i < SCROLL_LINKS.length; i++) {
                const SCROLL_LINK = SCROLL_LINKS[i];
                SCROLL_LINK.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.scrollTo(SCROLL_LINK);
                });
            }
        }

        this.financialScrollButton();
    }

    scrollTo(el) {
        let id = el.getAttribute('href').replace('#', '');
        if (document.getElementById(id)) {
            $('html, body').animate({
                scrollTop: $(`#${id}`).offset().top - 120
            }, 1000);
        }
    }

    /**
     * Scroll button for mtt financial tool
     */
    financialScrollButton() {
        
        const SCROLL_TOP_BTN = document.querySelector('.mtt-financial-analysis-tool__scroll-top');
        
        if (SCROLL_TOP_BTN) {

            // Scroll on click
            SCROLL_TOP_BTN.addEventListener('click', () => $("html, body").animate({ scrollTop: 0 }, "slow"));

            // Hide button on scroll
            window.addEventListener('scroll', () => {
                if (window.pageYOffset > 800) {
                    SCROLL_TOP_BTN.classList.add('mtt-financial-analysis-tool__scroll-top--show');
                    
                } else {
                    SCROLL_TOP_BTN.classList.remove('mtt-financial-analysis-tool__scroll-top--show');
                }
            });
        }
    }
}